import { useEffect, useRef } from 'react';
import { NavigationDirection } from './useNavigation';

/**
 * Saves scroll position when navigating away, restores it when navigating back.
 * On forward navigation, scrolls to top.
 */
export function useScrollRestoration(routeKey: string, direction: NavigationDirection) {
  const scrollPositions = useRef<Map<string, number>>(new Map());
  const prevRouteRef = useRef(routeKey);

  useEffect(() => {
    if (prevRouteRef.current === routeKey) return;

    // Save the scroll position for the route we're leaving
    scrollPositions.current.set(prevRouteRef.current, window.scrollY);
    prevRouteRef.current = routeKey;

    if (direction === 'back') {
      // Restore scroll position for the route we're going back to
      const saved = scrollPositions.current.get(routeKey);
      if (saved !== undefined) {
        requestAnimationFrame(() => {
          window.scrollTo(0, saved);
        });
      }
    } else {
      // Forward/tab navigation: scroll to top
      window.scrollTo(0, 0);
    }
  }, [routeKey, direction]);
}
